export const processResult = result => {
  result.data = null
  result.dataSet = null
  if (valueExists(result.jsonExpression) && result.jsonExpression !== '') {
    result.data = JSON.parse(result.jsonExpression)

    if (valueExists(result.data.type)) {
      result.dataSet = Ab.data.createDataSet(result.data)
    } else if (valueExists(result.data.records)) {
      result.dataSet = new Ab.data.DataSetList(result.data)
    }
  }

  return result
}

export const processParameters = parameters => {
  if (!valueExists(parameters)) {
    parameters = {}
  }
  if (parameters.constructor === Ab.data.Record) {
    parameters = {
      record: JSON.stringify(parameters)
    }
  } else if (parameters.constructor === Ab.data.DataSetList) {
    parameters = {
      records: JSON.stringify(parameters)
    }
  } else if (parameters.constructor === Array) {
    parameters = {
      records: JSON.stringify(parameters)
    }
  }

  return parameters
}

export const callMethod = (workflowRuleId, parameterArray) => {
  return new Promise(function(resolve, reject) {
    let wfrResult = function(result) {
      if (result.code === 'executed') {
        resolve(processResult(result))
      } else {
        reject(result.message)
      }
    }
    let options = {
      callback: wfrResult,
      errorHandler: reject,
      async: true,
      timeout: 100 * 1000
    }

    let parameters = {
      methodParameters: JSON.stringify(parameterArray),
      version: '2.0'
    }

    workflow.runWorkflowRule(workflowRuleId, parameters, null, options)
  })
}

export const call = (workflowRuleId, params) => {
  return new Promise(function(resolve, reject) {
    let wfrResult = function(result) {
      if (result.code === 'executed') {
        resolve(processResult(result))
      } else {
        reject(result.message)
      }
    }
    let options = {
      callback: wfrResult,
      errorHandler: reject,
      async: true,
      timeout: 100 * 1000
    }

    params.version = '2.0'
    workflow.runWorkflowRule(workflowRuleId, params, null, options)
  })
}
